import type {
  AddKeyIssueToMapFulfilledAction,
  AddNewCustomKeyIssueAction,
  CreateInitFulfilledAction,
  MapSetAction,
  MapSetImageAction,
  RemoveAllKeyIssuesFromMapAction,
  RemoveKeyIssueFromMapAction,
  ResetMap,
  SetMapDraggingAction,
  SetNewCustomDimensionTopicsAction,
  UpdateAIGeneratedMapProgressAction,
  UpdateAIGeneratedMapProgressSuccessAction,
  UploadMapDefaultAction,
  UploadMapFulfilledAction,
  UploadMapRejectedAction,
} from "domains/createMapDetail/actionTypes";
import { CreateMapTypes } from "domains/createMapDetail/actionTypes";
import type { AIGeneratedMapProgress, UploadMapMeta } from "domains/createMapDetail/types";
import type { NewCustomDimension } from "domains/dimension/dimension.types";
import type { GetAIGeneratedTopicDetailsSuccessAction } from "domains/topicDetail/actionTypes";
import { TopicDetailType } from "domains/topicDetail/actionTypes";
import type { Topic } from "entities/topics/types";

export const initiateCreateModeFulfilled = (payload: Topic): CreateInitFulfilledAction => ({
  type: CreateMapTypes.INIT_FULFILLED,
  payload,
});

export const uploadMap = (meta: UploadMapMeta): UploadMapDefaultAction => ({ meta, type: CreateMapTypes.UPLOAD });

export const uploadMapSuccessful = (payload: UploadMapFulfilledAction["payload"]): UploadMapFulfilledAction => ({
  type: CreateMapTypes.UPLOAD_FULFILLED,
  payload,
});

export const uploadMapFailure = (meta: UploadMapRejectedAction["meta"]): UploadMapRejectedAction => ({
  meta,
  type: CreateMapTypes.UPLOAD_REJECTED,
});

export const setCustomMapFields = (meta: Partial<Topic>): MapSetAction => ({
  type: CreateMapTypes.SET,
  meta,
});

export const setMapImage = (image: string): MapSetImageAction => ({
  type: CreateMapTypes.SET_IMAGE,
  payload: { image },
});

export const resetCreateMap = (): ResetMap => ({
  type: CreateMapTypes.RESET,
});

export const addDimensionToMapSuccess = (dimensionId: string): AddKeyIssueToMapFulfilledAction => ({
  type: CreateMapTypes.ADD_KEY_ISSUE_FULFILLED,
  dimensionId,
});

export const removeTopicFromMap = (payload: RemoveKeyIssueFromMapAction["payload"]): RemoveKeyIssueFromMapAction => ({
  type: CreateMapTypes.REMOVE_KEY_ISSUE,
  payload,
});

export const removeAllTopicsFromMap = (): RemoveAllKeyIssuesFromMapAction => ({
  type: CreateMapTypes.REMOVE_ALL_KEY_ISSUES,
});

export const enterAIGeneratedMap = () => ({
  type: CreateMapTypes.ENTER_AI_GENERATED_MODE,
});

export const exitAIGeneratedMap = () => ({
  type: CreateMapTypes.EXIT_AI_GENERATED_MODE,
});

export const toggleDraggingCustomMap = (meta: SetMapDraggingAction["meta"]): SetMapDraggingAction => ({
  type: CreateMapTypes.SET_DRAGGING,
  meta,
});

export const addNewCustomKeyIssueToMap = (payload: NewCustomDimension): AddNewCustomKeyIssueAction => ({
  type: CreateMapTypes.ADD_NEW_CUSTOM_KEY_ISSUE,
  payload,
});

export const getAIGeneratedMapDetailsSuccess = (payload: Topic): GetAIGeneratedTopicDetailsSuccessAction => ({
  type: TopicDetailType.GET_AI_GENERATED_DETAILS_SUCCESS,
  payload,
});

export const getAIGeneratedMapDetailsFailure = () => ({
  type: TopicDetailType.GET_AI_GENERATED_DETAILS_FAILURE,
});

export const getAIGeneratedMapDetailsNotValidPrompt = (errorCode: number) => ({
  type: TopicDetailType.GET_AI_GENERATED_DETAILS_NOT_VALID_PROMPT,
  errorCode,
});

export const updateAIGeneratedMapProgress = (): UpdateAIGeneratedMapProgressAction => ({
  type: CreateMapTypes.GET_AI_GENERATED_PROGRESS,
});

export const updateAIGeneratedMapProgressSuccess = (
  meta: AIGeneratedMapProgress,
): UpdateAIGeneratedMapProgressSuccessAction => ({
  type: CreateMapTypes.GET_AI_GENERATED_PROGRESS_SUCCESS,
  meta,
});

export const setNewCustomDimensionTopics = (
  payload: SetNewCustomDimensionTopicsAction["payload"],
): SetNewCustomDimensionTopicsAction => ({
  type: CreateMapTypes.SET_NEW_CUSTOM_DIMENSION_TOPICS,
  payload,
});
